import { useUser } from "@/contexts/user-provider";

import { useModule } from "@/hooks/use-module";

import { PERMISSIONS, hasPermission } from "@/lib/permissions";

/**
 * Whether this person gets the Follow-Up panel in place of the Waitlist. It
 * reads the day's appointments, so staff who can only manage the waitlist
 * keep the Waitlist button and tab.
 */
export function useFollowUpEnabled(): boolean {
  const hasModule = useModule("FOLLOW_UP");
  const { currentUser } = useUser();
  return hasModule && hasPermission(currentUser, PERMISSIONS.SCHEDULING_READ);
}
